export default __webpack_public_path__ + "static/media/shops.4a49d090.svg";